export default "__VITE_ASSET__B4Rhy8qW__"